import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { IModel } from 'app/model/base/annotation';
import { LinkedService } from './linkedservice';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { AzureKeyVault } from './key-vault';
import { Credential, IAttribute } from 'shell-models-lib';

@Metamodel.model({
    name: 'WebConnection',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.WebActivityLabel),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.WebActivityLabel)
    ]
})
export class WebActivityLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly AUTHENTICATION: IAttribute;
    public static readonly URL: IAttribute;
    public static readonly USERNAME: IAttribute;
    public static readonly RESOURCE: IAttribute;
    public static readonly TENANT: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly PFX: IAttribute;
    public static readonly CREDENTIAL: IAttribute;
    public static readonly ENABLECERTVALIDATION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_BaseUrl,
        association: 'URL',
        templatable: true
    })
    public url: string;

    @Metamodel.attribute({
        display: stringResources.UsernameLabel,
        association: 'USERNAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant?: string;

    @Metamodel.attribute({
        display: stringResources.Authentication,
        association: 'AUTHENTICATION',
        templatable: true
    })
    public authentication?: string;

    @Metamodel.attribute({
        association: 'RESOURCE',
        templatable: true
    })
    public aadResourceId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.WebActivity_Pfx,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PFX',
        templatable: true,
        accepts: ['String']
    })
    public pfx?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Credential,
        reference: true,
        association: 'CREDENTIAL',
        templatable: false
    })
    public credential?: Credential;

    @Metamodel.attribute({
        display: stringResources.ModelName_DisableCertValidation,
        association: 'ENABLECERTVALIDATION',
        templatable: true
    })
    public enableServerCertificateValidation?: boolean;
    public isSpnAuthRefMethodCredential?: boolean = false;
    public isSpnAuthKey?: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
